import "./styles.scss";

import React, { useState } from "react";
import { Link } from "gatsby";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";

import SiteLogo from "components/SiteLogo";
import Nav from "../Nav";
import Hamburger from "../../../Hamburger";
import Contact from "../../../Info";

import { getColorVariant } from "utils";

import { headerData } from "data/header";

const Sticky = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdown, setDropdown] = useState(null);

  const hideDropdown = () => setDropdown(null);

  return (
    <header
      className={clsx(
        "header-desktop-sticky",
        isOpen && isScrolled && "header-desktop-sticky--open",
        isScrolled && "header-desktop-sticky--visible"
      )}
      role="presentation"
      onMouseLeave={hideDropdown}
    >
      <div className="container-fluid">
        <SiteLogo />
        <div
          className="header-desktop-sticky__nav"
          role="presentation"
          onMouseEnter={hideDropdown}
        >
          <Nav />
        </div>
        <div className="header-desktop-sticky__actions">
          <div className="header-desktop-sticky__actions-buttons">
            <Link to={headerData.reservation.url} onMouseEnter={hideDropdown}>
              {headerData.reservation.label}
            </Link>
            <Link to={headerData.question.url} onMouseEnter={hideDropdown}>
              {headerData.question.label}
            </Link>
            <button
              className="has-arrow"
              type="button"
              onMouseEnter={() => setDropdown("call")}
            >
              {headerData.call.label}
              <span />
            </button>
          </div>
          <div className="header-desktop-sticky__toggle">
            <Hamburger
              isOpen={isOpen}
              onMouseEnter={hideDropdown}
              onClick={() => setIsOpen((prevOpen) => !prevOpen)}
            />
          </div>
          <AnimatePresence>
            {dropdown && isScrolled && (
              <motion.div
                className="header-desktop-sticky__actions-dropdown"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ type: "tween", duration: 0.3 }}
              >
                <div className="header-desktop-sticky__actions-dropdown-inner">
                  {headerData.call.data.map((item, index) => (
                    <div key={index}>
                      <Contact
                        title={item.name}
                        variant={getColorVariant(index + 1)}
                      >
                        <div>
                          <ul>
                            {item.phones.map((phone, index) => (
                              <li key={index}>
                                <a href={`tel:+48${phone.replaceAll(" ", "")}`}>
                                  {phone}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Contact>
                    </div>
                  ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </header>
  );
};

export default Sticky;
